(function() {
  function generateAntibot() {
    var num1 = Math.floor(Math.random() * 50) + 10;
    var num2 = Math.floor(Math.random() * num1);
    return { num1: num1, num2: num2, answer: num1 - num2 };
  }

  function updateAntibotLabelForForm(label, antibot, formStep1) {
    if (!label || !antibot) return;

    var template = antibotTemplateFor(formStep1);
    var questionText = template
      .replace("{num1}", String(antibot.num1))
      .replace("{num2}", String(antibot.num2));

    label.setAttribute("data-question", questionText);
    label.textContent = questionText;
  }

  function checkAntibot(value, answer) {
    if (answer === null || answer === undefined) return false;
    var trimmed = String(value || "").trim();
    if (!trimmed) return false;
    var parsed = parseInt(trimmed, 10);
    if (isNaN(parsed)) return false;
    return parsed === answer;
  }

  function setFormSubmitting(form, isSubmitting) {
    if (!form) return;
    var submitButton = form.querySelector(".form_step2_submit");
    var loader = form.querySelector(".form_step2_loader");
    if (submitButton) submitButton.disabled = isSubmitting;
    if (loader) loader.style.display = isSubmitting ? "block" : "none";
    form.dataset.submitting = isSubmitting ? "true" : "false";
  }

  function syncPhoneCode(form) {
    if (!form) return;
    form.querySelectorAll('input[type="tel"][id^="phone_step2_"]').forEach(function(input) {
      var wrapper = input.closest(".phone_wrapper");
      var codeNode = wrapper ? wrapper.querySelector(".phone-code") : null;
      var hiddenNode = wrapper ? wrapper.querySelector('input[type="hidden"][name="request[parent_phone_code]"]') : null;
      if (codeNode && hiddenNode) hiddenNode.value = codeNode.textContent.trim();
    });
  }

  function disableApplyNowStep1Fields(form) {
    if (!form || !form.closest(".apply-now-form")) return;

    form.querySelectorAll(".apply-now-step1 input, .apply-now-step1 select, .apply-now-step1 textarea").forEach(function(field) {
      field.disabled = true;
    });
  }

  function showFormSubmitMessage(form, html) {
    if (!form || !html) return;

    var containerId =
      (form.querySelector('[name="container_id"]') || {}).value ||
      (form.querySelector('[id^="msgPlacer"]') || {}).id;
    if (!containerId) return;

    var container = document.getElementById(containerId);
    if (!container) return;

    container.innerHTML = html;
    container.classList.remove("error");
    container.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function runJsResponse(jsResponse) {
    if (!jsResponse) return;

    var script = document.createElement("script");
    script.textContent = jsResponse;
    document.head.appendChild(script);
    document.head.removeChild(script);
  }

  function submitSecondaryRequestForm(form) {
    if (!form || form.dataset.submitting === "true") return;

    disableApplyNowStep1Fields(form);
    syncPhoneCode(form);
    setFormSubmitting(form, true);

    if (typeof window.callTouchHandlers !== "undefined" && window.callTouchHandlers) {
      window.callTouchHandlers.handleForm(form);
    }

    var formData = new FormData(form);
    if (!formData.get("form_step")) {
      formData.append("form_step", "2");
    }
    if (!formData.get("container_id")) {
      var containerNode = form.querySelector('[name="container_id"]');
      if (containerNode && containerNode.value) {
        formData.append("container_id", containerNode.value);
      }
    }
    if (typeof window.utmHandlers !== "undefined" && window.utmHandlers) {
      window.utmHandlers.fillFormUtm(formData, "request");
    }

    var csrfToken =
      (document.querySelector('meta[name="csrf-token"]') || {}).content ||
      (form.querySelector('input[name="authenticity_token"]') || {}).value;

    var successFallback = form.dataset.successMessage || "";

    fetch(form.action, {
      method: (form.method || "POST").toUpperCase(),
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": csrfToken || "",
        "Accept": "text/javascript"
      },
      credentials: "same-origin"
    })
      .then(function(response) {
        return response.text().then(function(text) {
          if (!response.ok) {
            var error = new Error("Request failed: " + response.status);
            error.responseText = text;
            throw error;
          }
          return text;
        });
      })
      .then(function(jsResponse) {
        runJsResponse(jsResponse);

        var containerId = (form.querySelector('[name="container_id"]') || {}).value;
        var container = containerId ? document.getElementById(containerId) : null;
        if (container && !container.textContent.trim() && successFallback) {
          showFormSubmitMessage(
            form,
            '<div class="form_success_message">' + successFallback + "</div>"
          );
        }
      })
      .catch(function(error) {
        console.error(error);
        if (error && error.responseText) {
          runJsResponse(error.responseText);
        }
        if (!form.querySelector(".form_success_message")) {
          alert("Ошибка отправки формы. Попробуйте ещё раз.");
        }
      })
      .finally(function() {
        setFormSubmitting(form, false);
      });
  }

  function currentLanguage(formStep1) {
    var form = formStep1 ? formStep1.closest("form") : null;
    var savedLang = (window.localStorage && window.localStorage.getItem("siteLanguage")) || "";
    var formLang = form ? String(form.dataset.lang || "").trim() : "";
    var htmlLang = String((document.documentElement && document.documentElement.lang) || "").trim();
    var pathLang = window.location.pathname.indexOf("/en-") >= 0 ? "en" : "ru";
    var lang = savedLang || formLang || htmlLang || pathLang;
    return String(lang).toLowerCase().indexOf("en") === 0 ? "en" : "ru";
  }

  function bindBirthDateInput(input) {
    if (!input || input.dataset.birthDateBound === "true") return;

    input.setAttribute("inputmode", "numeric");
    input.setAttribute("maxlength", "10");
    input.setAttribute("autocomplete", "bday");

    input.addEventListener("input", function(e) {
      var digits = String(e.target.value || "").replace(/\D/g, "").slice(0, 8);
      var formatted = digits;

      if (digits.length > 2) {
        formatted = digits.slice(0, 2) + "." + digits.slice(2);
      }
      if (digits.length > 4) {
        formatted = digits.slice(0, 2) + "." + digits.slice(2, 4) + "." + digits.slice(4);
      }

      e.target.value = formatted;

      if (formatted && typeof window.validateBirthDate === "function" && window.validateBirthDate(formatted)) {
        input.classList.remove("error");
      }
    });

    input.addEventListener("blur", function() {
      var value = String(input.value || "").trim();
      if (!value) {
        input.classList.remove("error");
        return;
      }

      if (typeof window.validateBirthDate === "function" && !window.validateBirthDate(value)) {
        input.classList.add("error");
      } else {
        input.classList.remove("error");
      }
    });

    input.dataset.birthDateBound = "true";
  }

  function antibotTemplateFor(formStep1) {
    return currentLanguage(formStep1) === "en"
      ? (formStep1 && formStep1.dataset.antibotTemplateEn) || "How much is {num1} - {num2}?"
      : (formStep1 && formStep1.dataset.antibotTemplateRu) || "Сколько будет {num1} - {num2}?";
  }

  function readCampusDataMap(formKey) {
    var node = document.getElementById("apply_now_campus_data_" + formKey);
    if (!node) return {};

    try {
      return JSON.parse(node.textContent || "{}");
    } catch (_e) {
      return {};
    }
  }

  function resolveCampusMeta(campusSelect, formKey) {
    if (!campusSelect) return { image: "", caption: "" };

    var campusId = String(campusSelect.value || "").trim();
    var map = readCampusDataMap(formKey);
    var fromMap = campusId ? (map[campusId] || map[parseInt(campusId, 10)]) : null;
    var option = campusSelect.selectedOptions && campusSelect.selectedOptions[0];

    var imageSrc = fromMap && fromMap.image ? fromMap.image : "";
    var captionText = fromMap && fromMap.caption ? fromMap.caption : "";

    if (option) {
      imageSrc = imageSrc || option.getAttribute("data-image") || "";
      captionText = captionText || option.getAttribute("data-caption") || option.textContent || "";
    }

    return { image: imageSrc, caption: captionText };
  }

  function updateCampusImage(formKey) {
    var campusSelect = document.getElementById("campus_" + formKey);
    var imageElement = document.getElementById("campusImage_" + formKey);
    var captionElement = document.getElementById("campusCaption_" + formKey);
    var desktopImageElement = document.getElementById("campusImage_" + formKey + "_desktop");
    var desktopCaptionElement = document.getElementById("campusCaption_" + formKey + "_desktop");

    if (!campusSelect) return;

    var apply = function() {
      var meta = resolveCampusMeta(campusSelect, formKey);

      if (imageElement && meta.image) {
        imageElement.src = meta.image;
        imageElement.alt = meta.caption || imageElement.alt;
      }
      if (desktopImageElement && meta.image) {
        desktopImageElement.src = meta.image;
        desktopImageElement.alt = meta.caption || desktopImageElement.alt;
      }
      if (captionElement) captionElement.textContent = meta.caption;
      if (desktopCaptionElement) desktopCaptionElement.textContent = meta.caption;
    };

    if (campusSelect.dataset.campusImageBound !== "true") {
      campusSelect.addEventListener("change", apply);
      campusSelect.dataset.campusImageBound = "true";
    }

    apply();
  }

  window.updateSecondaryLeadCampusImage = updateCampusImage;
  window.updateCampusImage = updateCampusImage;

  function updateStep2PhoneState(formKey) {
    var step1Selector = document.getElementById("phoneFlagSelector_" + formKey);
    var step1Code = document.getElementById("phoneCode_" + formKey);
    var step1Flag = document.getElementById("phoneFlagImg_" + formKey);
    var step2Selector = document.getElementById("phoneFlagSelector_step2_" + formKey);
    var step2Code = document.getElementById("phoneCode_step2_" + formKey);
    var step2Flag = document.getElementById("phoneFlagImg_step2_" + formKey);
    var step2Input = document.getElementById("phone_step2_" + formKey);
    var phoneStep1 = document.getElementById("phone_" + formKey);

    if (step2Code && step1Code) step2Code.textContent = step1Code.textContent.trim();
    if (step2Flag && step1Flag) {
      var clonedFlag = step1Flag.cloneNode(true);
      clonedFlag.id = step2Flag.id;
      step2Flag.replaceWith(clonedFlag);
    }
    if (step2Selector && step1Selector && step1Selector.dataset.selectedIso) {
      step2Selector.dataset.selectedIso = step1Selector.dataset.selectedIso;
    }

    if (step2Input && phoneStep1) {
      step2Input.value = phoneStep1.value.trim();
    }
  }

  function getStep2Country(formKey) {
    var codeNode = document.getElementById("phoneCode_step2_" + formKey);
    if (!codeNode || typeof window.getCountryByCode !== "function") return null;
    return window.getCountryByCode(codeNode.textContent.trim());
  }

  function formatStep2PhoneValue(input, formKey) {
    if (!input || typeof window.formatPhoneNumber !== "function") return;
    var country = getStep2Country(formKey);
    if (!country) return;

    var formatted = window.formatPhoneNumber(input.value || "", country.code);
    if (formatted !== input.value) {
      input.value = formatted;
    }

    input.dataset.countryCode = country.code;
    if (country.placeholder) {
      input.placeholder = country.placeholder;
      input.dataset.correctPlaceholder = country.placeholder;
    }
  }

  function bindStep2PhoneFormatter(input, formKey) {
    if (!input || input.dataset.step2FormatterBound === "true") return;

    var applyFormatting = function() {
      formatStep2PhoneValue(input, formKey);
    };

    input.addEventListener("input", applyFormatting);
    input.addEventListener("blur", applyFormatting);
    input.dataset.step2FormatterBound = "true";
    applyFormatting();
  }

  function isStep2PhoneValid(formKey) {
    var input = document.getElementById("phone_step2_" + formKey);
    var codeNode = document.getElementById("phoneCode_step2_" + formKey);
    if (!input || !codeNode) return false;

    var phoneCode = codeNode.textContent.trim() || "+7";
    var digits = normalizePhoneDigits(input.value, phoneCode);
    if (!digits) return false;

    if (typeof window.validatePhoneNumber === "function" && typeof window.getCountryByCode === "function") {
      var country = window.getCountryByCode(phoneCode);
      if (country) {
        var validation = window.validatePhoneNumber(input.value || "", phoneCode);
        if (validation.valid) return true;
      }
    }

    var minDigits = phoneCode === "+998" ? 9 : 10;
    return digits.length >= minDigits;
  }

  function syncAntibotData(formStep1, antibot) {
    if (!formStep1 || !antibot) return;
    formStep1.dataset.antibotNum1 = String(antibot.num1);
    formStep1.dataset.antibotNum2 = String(antibot.num2);
  }

  function parseAntibotQuestion(text) {
    var match = String(text || "").match(/(\d+)\s*(?:-|−|–|minus|минус)\s*(\d+)/i);
    if (!match) return null;

    var num1 = parseInt(match[1], 10);
    var num2 = parseInt(match[2], 10);
    if (isNaN(num1) || isNaN(num2) || num2 >= num1) return null;

    return { num1: num1, num2: num2, answer: num1 - num2 };
  }

  function readAntibotFromForm(formStep1, antibotLabel) {
    if (!formStep1) return null;

    var num1 = parseInt(formStep1.dataset.antibotNum1, 10);
    var num2 = parseInt(formStep1.dataset.antibotNum2, 10);
    if (!isNaN(num1) && !isNaN(num2) && num2 < num1) {
      return { num1: num1, num2: num2, answer: num1 - num2 };
    }

    if (antibotLabel) {
      var fromLabel = parseAntibotQuestion(
        antibotLabel.getAttribute("data-question") || antibotLabel.textContent
      );
      if (fromLabel) {
        syncAntibotData(formStep1, fromLabel);
        return fromLabel;
      }
    }

    var antibot = generateAntibot();
    syncAntibotData(formStep1, antibot);
    return antibot;
  }

  function resolveAntibotAnswer(formStep1, antibotLabel) {
    if (formStep1) {
      var num1 = parseInt(formStep1.dataset.antibotNum1, 10);
      var num2 = parseInt(formStep1.dataset.antibotNum2, 10);
      if (!isNaN(num1) && !isNaN(num2) && num2 < num1) {
        return num1 - num2;
      }
    }

    if (antibotLabel) {
      var parsed = parseAntibotQuestion(
        antibotLabel.getAttribute("data-question") || antibotLabel.textContent
      );
      if (parsed) {
        syncAntibotData(formStep1, parsed);
        return parsed.answer;
      }
    }

    return null;
  }

  function normalizePhoneDigits(value, countryCode) {
    var digits = String(value || "").replace(/\D/g, "");
    if (countryCode === "+7") {
      if (digits.length >= 11 && (digits.charAt(0) === "7" || digits.charAt(0) === "8")) {
        digits = digits.slice(1);
      }
    }
    return digits;
  }

  function isStep1PhoneValid(phoneInput, formKey) {
    if (!phoneInput) return false;

    var phoneCodeNode = document.getElementById("phoneCode_" + formKey);
    var phoneCode = phoneCodeNode ? phoneCodeNode.textContent.trim() : "+7";
    var digits = normalizePhoneDigits(phoneInput.value, phoneCode);
    if (!digits) return false;

    if (typeof window.validatePhoneNumber === "function" && typeof window.getCountryByCode === "function") {
      var country = window.getCountryByCode(phoneCode);
      if (country) {
        var validation = window.validatePhoneNumber(digits, phoneCode);
        if (validation.valid) return true;
      }
    }

    var minDigits = phoneCode === "+998" ? 9 : 10;
    return digits.length >= minDigits;
  }

  function initPhoneFlagSelectors(formKey, onCountryChange) {
    if (typeof window.initPhoneFlagSelector !== "function") return;

    var initStep1 = function() {
      window.initPhoneFlagSelector({
        selectorId: "phoneFlagSelector_" + formKey,
        modalId: "phoneModal_" + formKey,
        flagImgId: "phoneFlagImg_" + formKey,
        codeId: "phoneCode_" + formKey,
        commentId: "comment_" + formKey,
        onCountryChange: onCountryChange
      });
    };

    var initStep2 = function() {
      if (typeof window.initPhoneFlagSelectorStep2 !== "function") return;
      window.initPhoneFlagSelectorStep2(
        "phoneFlagSelector_step2_" + formKey,
        "phoneModal_step2_" + formKey,
        "phoneFlagImg_step2_" + formKey,
        "phoneCode_step2_" + formKey
      );
    };

    var initAll = function() {
      initStep1();
      initStep2();
    };

    if (!window.countryCodesData) {
      setTimeout(initAll, 100);
    } else {
      initAll();
    }
  }

  function initForm(formStep1) {
    if (!formStep1 || formStep1.dataset.leadFormInitialized === "true") return;

    var formKey = formStep1.dataset.secondaryLeadForm || formStep1.getAttribute("data-secondary-lead-form");
    if (!formKey) return;

    var isApplyNowSingle = !!formStep1.closest(".apply-now-form");
    var form = formStep1.closest("form");
    var phone = document.getElementById(isApplyNowSingle ? "phone_step2_" + formKey : "phone_" + formKey);
    var comment = document.getElementById(
      isApplyNowSingle ? "antibot_step2_" + formKey : "comment_" + formKey
    );
    var nextButton = isApplyNowSingle ? null : document.getElementById("submitBtn_" + formKey);
    var step2 = document.getElementById("formStep2_" + formKey);
    var phoneStep2 = document.getElementById("phone_step2_" + formKey);
    var parentName = document.getElementById("parent_name_" + formKey);
    var email = document.getElementById("email_" + formKey);
    var birthDate = document.getElementById("birth_date_" + formKey);
    var campusSelect = document.getElementById("campus_" + formKey);
    var requestKindSelect = document.getElementById("request_kind_" + formKey);
    var submitStep2 = document.getElementById("submitStep2_" + formKey);
    var phoneCodeField = document.getElementById("parent_phone_code_" + formKey);
    var antibotLabel = document.getElementById(
      isApplyNowSingle ? "antibotLabel_step2_" + formKey : "antibotLabel_" + formKey
    );

    if (isApplyNowSingle) {
      if (!phone || !comment || !submitStep2) return;
    } else if (!phone || !comment || !nextButton || !step2 || !submitStep2) {
      return;
    }

    var antibot = readAntibotFromForm(formStep1, antibotLabel);
    if (!isApplyNowSingle) {
      updateAntibotLabelForForm(antibotLabel, antibot, formStep1);
    }

    var updateStep1State = function() {
      if (isApplyNowSingle || !nextButton) return;
      var phoneValid = isStep1PhoneValid(phone, formKey);
      var answer = resolveAntibotAnswer(formStep1, antibotLabel);
      var antibotValid = answer !== null && checkAntibot(comment.value, answer);
      nextButton.disabled = !(phoneValid && antibotValid);
    };

    if (!isApplyNowSingle) {
      window.refreshSecondaryLeadStep1 = updateStep1State;
      initPhoneFlagSelectors(formKey, updateStep1State);
    } else {
      initPhoneFlagSelectors(formKey);
    }

    if (!isApplyNowSingle && form && step2 && step2.parentElement !== form) {
      form.insertBefore(step2, formStep1.nextSibling);
    }

    function markField(field, valid) {
      if (!field) return;
      field.classList.toggle("error", !valid);
    }

    function showStep2() {
      formStep1.style.display = "none";
      step2.style.display = "flex";
    }

    function validateStep2() {
      var isValid = true;
      var missingFields = [];

      var phoneValid = isStep2PhoneValid(formKey);
      var phoneInput = document.getElementById("phone_step2_" + formKey);
      markField(phoneInput, phoneValid);
      if (!phoneValid) {
        isValid = false;
        missingFields.push("Телефон");
      }

      var parentNameValue = parentName ? String(parentName.value || "").trim() : "";
      markField(parentName, !!parentNameValue);
      if (!parentNameValue) {
        isValid = false;
        missingFields.push("Имя и фамилия родителя");
      }

      var emailValue = email ? String(email.value || "").trim() : "";
      var emailValid = !!emailValue;
      if (emailValid && typeof window.validateEmail === "function") {
        emailValid = window.validateEmail(emailValue);
      } else if (emailValid) {
        emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
      }
      markField(email, emailValid);
      if (!emailValid) {
        isValid = false;
        missingFields.push("Email");
      }

      var birthDateValue = birthDate ? String(birthDate.value || "").trim() : "";
      if (birthDateValue && typeof window.validateBirthDate === "function" && !window.validateBirthDate(birthDateValue)) {
        markField(birthDate, false);
        isValid = false;
        missingFields.push("Дата рождения");
      } else if (birthDate) {
        markField(birthDate, true);
      }

      var campusValue = campusSelect ? String(campusSelect.value || "").trim() : "";
      markField(campusSelect, !!campusValue);
      if (!campusValue) {
        isValid = false;
        missingFields.push("Кампус");
      }

      if (requestKindSelect) {
        var requestKindValue = String(requestKindSelect.value || "").trim();
        markField(requestKindSelect, !!requestKindValue);
        if (!requestKindValue) {
          isValid = false;
          missingFields.push("Тип заявки");
        }
      }

      var antibotInput = document.getElementById("antibot_step2_" + formKey);
      if (antibotInput) {
        var antibotLabelStep2 = document.getElementById("antibotLabel_step2_" + formKey) || antibotLabel;
        var antibotAnswer = resolveAntibotAnswer(formStep1, antibotLabelStep2);
        var antibotValid = antibotAnswer !== null && checkAntibot(antibotInput.value, antibotAnswer);
        markField(antibotInput, antibotValid);
        if (!antibotValid) {
          isValid = false;
          missingFields.push("Антибот");
        }
      }

      return { isValid: isValid, missingFields: missingFields };
    }

    if (!isApplyNowSingle) {
      var onStep1FieldChange = function(event) {
        if (event && event.target === phone && phone.value) {
          phone.classList.remove("error");
        }
        updateStep1State();
      };

      phone.addEventListener("input", onStep1FieldChange);
      phone.addEventListener("change", updateStep1State);
      phone.addEventListener("blur", updateStep1State);
      phone.addEventListener("keyup", updateStep1State);
      phone.addEventListener("paste", function() {
        setTimeout(updateStep1State, 0);
      });
      phone.addEventListener("animationstart", function(e) {
        if (e.animationName === "onAutoFillStart" || e.animationName === "onAutoFillCancel") {
          updateStep1State();
        }
      });
      comment.addEventListener("input", updateStep1State);
      comment.addEventListener("blur", updateStep1State);
      comment.addEventListener("change", updateStep1State);
      comment.addEventListener("keyup", updateStep1State);

      if (form) {
        form.addEventListener("input", function(event) {
          if (event.target === phone || event.target === comment) {
            updateStep1State();
          }
        });
      }

      updateStep1State();
      setTimeout(updateStep1State, 0);
      setTimeout(updateStep1State, 300);
      setTimeout(updateStep1State, 1000);
      window.addEventListener("load", updateStep1State);

      var pollUntil = Date.now() + 12000;
      var pollId = setInterval(function() {
        updateStep1State();
        if (Date.now() >= pollUntil) clearInterval(pollId);
      }, 400);
    }

    if (campusSelect) {
      campusSelect.addEventListener("change", function() {
        campusSelect.classList.remove("error");
      });
      updateCampusImage(formKey);
    }

    if (requestKindSelect) {
      requestKindSelect.addEventListener("change", function() {
        requestKindSelect.classList.remove("error");
      });
    }

    if (email) {
      email.addEventListener("input", function() {
        if (!email.value || typeof window.validateEmail !== "function" || window.validateEmail(email.value)) {
          email.classList.remove("error");
        }
      });
    }

    if (birthDate) {
      bindBirthDateInput(birthDate);
    }

    if (parentName) {
      parentName.addEventListener("input", function() {
        parentName.classList.remove("error");
      });
    }

    if (phoneStep2) {
      phoneStep2.addEventListener("input", function() {
        if (phoneStep2.value) {
          phoneStep2.classList.remove("error");
        }
      });
      bindStep2PhoneFormatter(phoneStep2, formKey);
    }

    if (nextButton) {
      nextButton.addEventListener("click", function() {
        if (nextButton.disabled) return;
        if (!step2) return;
        showStep2();
        updateStep2PhoneState(formKey);
        formatStep2PhoneValue(phoneStep2, formKey);
        initPhoneFlagSelectors(formKey, updateStep1State);

        if (form && typeof window.submitStep1Form === "function") {
          var phoneCodeNode = document.getElementById("phoneCode_" + formKey);
          var phoneCode = phoneCodeNode ? phoneCodeNode.textContent.trim() : "+7";
          window.submitStep1Form(form, phone, phoneCode, "msgPlacer_" + formKey);
        }

        if (typeof window.translateStep2Form === "function") {
          window.translateStep2Form("formStep2_" + formKey);
        }
      });
    }

    if (!submitStep2) return;

    submitStep2.addEventListener("click", function(event) {
      event.preventDefault();
      event.stopPropagation();

      var result;
      try {
        result = validateStep2();
      } catch (validationError) {
        console.error(validationError);
        alert("Ошибка проверки формы. Обновите страницу и попробуйте снова.");
        return;
      }

      if (!result.isValid) {
        var message = "Пожалуйста, заполните обязательные поля: " + result.missingFields.join(", ");
        alert(message);
        showFormSubmitMessage(form, '<div class="form_error_message">' + message + "</div>");
        return;
      }

      if (phoneCodeField) {
        var codeNode = document.getElementById("phoneCode_step2_" + formKey);
        phoneCodeField.value = codeNode ? codeNode.textContent.trim() : "";
      }

      if (!form) {
        alert("Форма не найдена. Обновите страницу.");
        return;
      }

      if (typeof window.submitSecondaryRequestForm === "function") {
        setFormSubmitting(form, true);
        window.submitSecondaryRequestForm(form);
        return;
      }

      alert("Скрипт формы ещё загружается. Подождите пару секунд и нажмите снова.");
    });

    formStep1.dataset.leadFormInitialized = "true";
  }

  function init() {
    document.querySelectorAll("[data-secondary-lead-form]").forEach(initForm);
    syncApplyNowPhoneCodeWithRegion();
    bindApplyNowRegionPhoneSync();
  }

  function detectRegionIso() {
    var curCountryEl = document.getElementById("curCountry");
    var regionText = curCountryEl ? String(curCountryEl.textContent || "").trim() : "";
    if (
      regionText === "Узбекистан" ||
      regionText === "Uzbekistan"
    ) {
      return "uz";
    }
    return "ru";
  }

  function setApplyNowPhoneSelector(selectorId, codeId, flagId, phoneInputId, iso) {
    var selector = document.getElementById(selectorId);
    var codeNode = document.getElementById(codeId);
    var flagNode = document.getElementById(flagId);
    var inputNode = document.getElementById(phoneInputId);

    if (!selector || !codeNode) return;

    var config = iso === "uz"
      ? { code: "+998", placeholder: "71 209 66 69", flag: "/landing_2025/src/icon/uzb.svg" }
      : { code: "+7", placeholder: "999 999 99 99", flag: "/landing_2025/src/icon/rus.svg" };

    selector.dataset.selectedIso = iso;
    codeNode.textContent = config.code;

    if (flagNode) {
      if (flagNode.tagName === "IMG") {
        flagNode.src = config.flag;
        flagNode.setAttribute("data-country", iso);
      } else {
        // Если флаг уже заменён на span-emoji другими скриптами, возвращаем img для единообразия.
        var img = document.createElement("img");
        img.className = "phone-flag-icon phoneFlagImg flag-emoji";
        img.id = flagId;
        img.src = config.flag;
        img.alt = "";
        img.width = 22;
        img.height = 22;
        img.setAttribute("data-country", iso);
        flagNode.replaceWith(img);
      }
    }

    if (inputNode) {
      inputNode.placeholder = config.placeholder;
      inputNode.dataset.countryCode = config.code;
      inputNode.dataset.correctPlaceholder = config.placeholder;
    }
  }

  function syncApplyNowPhoneCodeWithRegion() {
    var iso = detectRegionIso();
    setApplyNowPhoneSelector(
      "phoneFlagSelector_apply_now",
      "phoneCode_apply_now",
      "phoneFlagImg_apply_now",
      "phone_apply_now",
      iso
    );
    setApplyNowPhoneSelector(
      "phoneFlagSelector_step2_apply_now",
      "phoneCode_step2_apply_now",
      "phoneFlagImg_step2_apply_now",
      "phone_step2_apply_now",
      iso
    );
  }

  function bindApplyNowRegionPhoneSync() {
    if (window.__applyNowRegionPhoneSyncBound) return;
    window.__applyNowRegionPhoneSyncBound = true;

    document.addEventListener("click", function(event) {
      var option = event.target.closest(".country_option");
      if (!option) return;
      setTimeout(syncApplyNowPhoneCodeWithRegion, 0);
    });

    var curCountryEl = document.getElementById("curCountry");
    if (curCountryEl && typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function() {
        syncApplyNowPhoneCodeWithRegion();
      });
      observer.observe(curCountryEl, { childList: true, characterData: true, subtree: true });
    }
  }

  if (typeof window.generateAntibot !== "function") window.generateAntibot = generateAntibot;
  if (typeof window.checkAntibot !== "function") window.checkAntibot = checkAntibot;
  if (typeof window.setFormSubmitting !== "function") window.setFormSubmitting = setFormSubmitting;
  if (typeof window.submitSecondaryRequestForm !== "function") window.submitSecondaryRequestForm = submitSecondaryRequestForm;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", function() {
    init();
    setTimeout(init, 500);
  });
})();
